import React from 'react';
import "./Button.scss"

function Button(props) {
    return (
        <button type={'button'} className={'default-button'} {...props}/>
    );
}

export default Button;